import { AfterViewInit, OnDestroy,Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { DataTableDirective } from 'angular-datatables';
import { map } from 'rxjs/operators';
import { AlertService, AppService, RoleService } from '../../_services/index';
import $ from 'jquery/dist/jquery';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class Role {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html'
})
export class RoleComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, {static: false})
    dtElement: DataTableDirective;

    dtOptions: DataTables.Settings = {}; //  DataTable
    dtTrigger = new Subject(); //  DataTable
    roleList: Role[] = []; // Table Data list
    clicked = false;
    isSubmitted = false;
    // countryAddForm: FormGroup;
    getRole = {
      id:'',
      name: '',
      description: '',
      is_active: 'N'
    };
    modalReference:NgbActiveModal;
    modalTitle:string;
    constructor(
                public router: Router,
                private dataService:RoleService,
                private alertService: AlertService,
                private AppService: AppService,
                private modalService: NgbModal
               ) { }
    role = {
      id:'',
      name: '',      
      description: '',
      is_active: 'Y'
    };
    showloding = true;
    lodingImage = false;

    ngOnInit() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.allRole();
    }
  
    allRole(){
      this.loadShow();
      this.dataService.getAllRole()
          .pipe().subscribe(data => { 
            this.roleList = data['roles']; 
            // this.dtTrigger.next(); // Data Table
            this.rerender();
            this.loadHide();
          });
    }
  
    open(content) {
      this.isSubmitted = false;
      this.role.id='';
      this.role.name = '',
      this.role.description = '',
      this.role.is_active = 'Y';
      this.modalTitle = "Add Role";
      this.modalReference = this.modalService.open(content);
    }
  
    edit(id,content){
      this.loadShow();
      this.dataService.getRole(id)
          .pipe().subscribe(data => { 
                  this.getRole = data['roles']; 
                  this.role = {
                        id:this.getRole.id,
                        name:this.getRole.name,                        
                        description:this.getRole.description,
                        is_active:this.getRole.is_active
                  };
                  this.loadHide();
                  this.modalTitle = "Edit Role";
                  this.modalReference = this.modalService.open(content);
              });
          }


    save(val,f){ 
      this.isSubmitted = true;
      $(':submit').attr('disabled', 'disabled');
      if(f.form.valid) { 
        this.loadShow;       
        if(val.id == ''){
          this.dataService.save(this.role)
              .pipe().subscribe(data =>{
                this.loadHide();
                this.modalReference.close();
                // this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Role saved successfully', true);
                this.allRole();
              },error =>{
                this.loadHide();
                this.alertService.error(error);
              });
        }else{
          this.dataService.roleUpdate(this.role)
              .pipe().subscribe(data =>{
                this.loadHide();
                this.modalReference.close();
                // this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Role updated successfully', true);
                this.allRole();
              },error =>{
                this.loadHide();
                this.alertService.error(error);
              });
        }
      }
      this.loadHide;
    }
  
    delete(id){
      // if(confirm("Are you sure to delete")) {
        this.dataService.roleDelete(id)
            .pipe().subscribe(data =>{
              if(data['status']==200){
                // this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Role deleted successfully', true);
                this.allRole();
              }else{
                this.alertService.error('Role error');
              }
            },error =>{
              this.alertService.error(error);
            });
      // }
    }

    ngAfterViewInit(): void {
      this.dtTrigger.next();
    }
  
    ngOnDestroy(): void {
      this.dtTrigger.unsubscribe();
    }
  
    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    }
  
    loadShow(){
      this.showloding = true;
      this.lodingImage = false;
    }
  
    loadHide(){
      this.showloding = false;
      this.lodingImage = true;
    }

}
